// Some course/training slugs come back from the backend malformed – e.g.
// "digital-marketing,digital-marketing" – and the slug lookup 500s on the
// raw value. Always route on the first clean token, falling back to the id.

export const cleanSlug = (value) => {
  if (value === undefined || value === null) return "";
  return String(value).split(/[,\s]+/)[0].trim();
};

// Value to put in a /course/:id or /training/:id URL for a list item.
export const courseParam = (course = {}) =>
  cleanSlug(course.slug) || course.id;
